import { Role } from "../../types/role";

const RMDan: Role = {
  primary: [
    "Abschluss",
    "Antizipation",
    "Entscheidungen",
    "Konzentration",
    "Nervenstaerke",
    "OhneBall",
    "Balance",
  ],
  secondary: ["Ballannahme", "Technik", "Einsatzfreude", "Antritt", "Ausdauer"],
  physis: "mittelfeld",
};

export const RMD = {
  RMDan,
};
